import { Box, Typography } from "@outschool/backpack";
import {
  LeaderFragmentFragment,
  LightActivityFragmentFragment,
  ParentFragmentFragment,
} from "@outschool/gql-frontend-generated";
import { Trans, useTranslation } from "@outschool/localization";
import { createPathWithActivity } from "@outschool/routes";
import * as Time from "@outschool/time";
import { dayjs } from "@outschool/time";
import { UserHeadshotImage } from "@outschool/ui-components-shared";
import { useLinkComponent } from "@outschool/ui-utils";
import React from "react";

type ReviewHeaderProps = {
  user: ParentFragmentFragment | LeaderFragmentFragment;
  userName: string;
  userLink: string;
  responseTime: dayjs.Dayjs;
  activity?: LightActivityFragmentFragment;
};

export const ReviewHeader: React.FunctionComponent<ReviewHeaderProps> = ({
  user,
  userName,
  userLink,
  responseTime,
  activity = null,
}) => {
  const { t } = useTranslation(
    "ui-components-website\\src\\Reviews\\PublicReviewQuote\\ReviewHeader"
  );
  const Link = useLinkComponent();
  const dateOfResponse = Time.formatDate(responseTime);
  const nameOfClass = activity?.title;

  return (
    <Box
      flex
      sx={{
        marginTop: "0.5em",
        marginBottom: "1em",
        alignItems: "center",
      }}
    >
      <UserHeadshotImage
        user={user}
        size={32}
        sx={{
          display: "inline-block",
          verticalAlign: "middle",
          marginRight: "small",
        }}
      />
      <Box>
        {activity ? (
          <Trans t={t}>
            <Typography
              variant="inherit"
              sx={{
                color: "grey.500",
              }}
            >
              <Link to={userLink}>
                <span>{{ userName }}</span>
              </Link>{" "}
              on {{ dateOfResponse }} about{" "}
              <Link to={createPathWithActivity(activity)}>
                <span>{{ nameOfClass }}</span>
              </Link>
            </Typography>
          </Trans>
        ) : (
          <Trans t={t}>
            <Link to={userLink} sx={{ color: "blue2" }}>
              <Typography
                variant="inherit"
                sx={{
                  color: "primary.700",
                }}
              >
                {{ userName }}
              </Typography>
            </Link>
            <Typography
              variant="inherit"
              sx={{
                marginLeft: "0.25em",
                color: "grey.500",
              }}
            >
              on {{ dateOfResponse }}
            </Typography>
          </Trans>
        )}
      </Box>
    </Box>
  );
};
